import { FC, useContext, useMemo } from 'react';

import {
  GroupedCoverageCardsList,
} from '../../../../../shared';
import { ContentSection } from '../../../../../../../../../shared/components';

import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import {
  GenericDataFormContext,
  QuotationInfoContext,
} from '../../../../../shared/contexts';
import { StepFourFormContext } from '../../contexts/StepFourForm';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';

import {
  groupCardsByCommonSection,
  GroupedCoveragesCardsResult,
} from '../../../../../utils';

interface CoveragesCommerceSectionProps {
  tabKey: number;
}

export const CoveragesCommerceSection: FC<CoveragesCommerceSectionProps> = ({
  tabKey,
}) => {
  const { stepFourCommerceQuotationForm } = useContext(StepFourFormContext);
  const { allCoveragesPerPlan, getRelationWithOtherCoverage } = useContext(GenericDataFormContext);
  const { stepThreeForm, plansByActivityList  } = useContext(StepThreeFormContext);
  const { rubricSelected } = useContext(StepTwoFormContext)
   const { quotationInfo, savedQuotation, quotationToRenewal } = useContext( QuotationInfoContext );

  const savedBien = useMemo(() => {
    const quotation = savedQuotation ?? quotationToRenewal;

    return quotation?.bienes?.find(
      (bien: any, index: number) =>
        Number(bien.numeroComponente ?? index + 1) === Number(tabKey)
    );
  }, [savedQuotation, quotationToRenewal, tabKey]);

  const planSelected =
    stepThreeForm?.getFieldValue(`plan-tab-${tabKey}`) ??
    savedBien?.planSeleccionado?.toString();

  const planSelectedLabel =
    plansByActivityList.find((el) => el.value === planSelected)?.label ?? '';

  const allCoveragesByTab = useMemo(() => {
    const riskCode =
      rubricSelected?.codigoDeRiesgo ??
      savedBien?.coberturasSeleccionadas?.[0]?.codigoRiesgo;

    return allCoveragesPerPlan
      ?.find((el) => String(el.plan) === String(planSelected))
      ?.coverages?.filter((coverage) =>
        riskCode ? String(coverage.codigoRiesgo) === String(riskCode) : true
      );
  }, [allCoveragesPerPlan, planSelected, rubricSelected, savedBien]);

  const groupedCoveragesCardsResult: GroupedCoveragesCardsResult =
    useMemo(() => {      
      return allCoveragesByTab
        ? groupCardsByCommonSection(allCoveragesByTab, 'codigoFamilia')
        : {};
    }, [allCoveragesByTab, planSelectedLabel]);

  return (
    <ContentSection level='h3' title='Coberturas' hasCard={false}>
      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (!groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`commerce-tab-${tabKey}`}
              usedFormToCoverageCard={stepFourCommerceQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}

      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`commerce-tab-${tabKey}`}
              usedFormToCoverageCard={stepFourCommerceQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
            />
          );
        }
      })}
    </ContentSection>
  );
};
